import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const ELEMENT_COLORS = {
  Fire: "#EF4444",
  Water: "#3B82F6",
  Grass: "#22C55E",
  Electric: "#EAB308",
  Ice: "#06B6D4",
  Ground: "#A8A29E",
  Dark: "#8B5CF6",
  Dragon: "#D946EF",
  Neutral: "#94A3B8",
};

export const MAP_IMAGE = "/palworld-map-v1.png";

export function apiError(detail) {
  if (detail == null) return "Une erreur est survenue.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}
